import React from "react";

function Pass({color}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10V7V7C8 4.791 9.791 3 12 3V3C14.209 3 16 4.791 16 7V7V10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 21H7C5.895 21 5 20.105 5 19V12C5 10.895 5.895 10 7 10H17C18.105 10 19 10.895 19 12V19C19 20.105 18.105 21 17 21Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15.5409C8.997 15.5409 8.995 15.5429 8.995 15.5459C8.995 15.5489 8.997 15.5509 9 15.5509C9.003 15.5509 9.005 15.5489 9.005 15.5459C9.005 15.5429 9.003 15.5409 9 15.5409"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0049 15.5409C12.0019 15.5409 11.9999 15.5429 11.9999 15.5459C11.9999 15.5489 12.0029 15.5509 12.0049 15.5509C12.0079 15.5509 12.0099 15.5489 12.0099 15.5459C12.0099 15.5429 12.0079 15.5409 12.0049 15.5409"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 15.5409C14.997 15.5409 14.995 15.5429 14.995 15.5459C14.995 15.5489 14.997 15.5509 15 15.5509C15.003 15.5509 15.005 15.5489 15.005 15.5459C15.005 15.5429 15.003 15.5409 15 15.5409"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Pass;
